module.exports = __webpack_public_path__ + "static/media/account_widget.09292a3e.png";